import { Component, Input, OnInit } from '@angular/core';
import { PackagingSystemExpenseResultsDto, PackagingUnitExpenseResultsDto } from 'src/app/data-transfer/entities/evaluation-entities/expense-result-dto';
import { ExpenseCalculationParentComponent } from '../expense-calculation-parent/expense-calculation-parent.component';
import { ActivatedRoute } from '@angular/router';
import { PackagingPart } from 'src/app/model/packaging-part-enum';
import { DisplayType } from '../expense-calculation-html-template/expense-calculation-html-template.component';
import { PackagingSystemDto } from 'src/app/data-transfer/entities/packaging-system-entities/packaging-system-dto';
import { TreeLevelParent } from '../../shared-components/parent-components/packaging-part-tree/packaging-part-tree.component';
import { ExpenseCalculationService } from 'src/app/util/analyses-util/expense-calculation-service';
import { AuthService } from 'src/app/services/auth-service';

@Component({
  selector: 'app-expense-calculation-packaging-system',
  templateUrl: './expense-calculation-packaging-system.component.html',
  styleUrls: ['./expense-calculation-packaging-system.component.scss']
})
export class ExpenseCalculationPackagingSystemComponent extends ExpenseCalculationParentComponent implements OnInit {
  selectedExpenseResults!: PackagingSystemExpenseResultsDto[];
  expenseResults!: PackagingSystemExpenseResultsDto[][];
  packagingSystem!: PackagingSystemDto;
  isUserValidator = false;

  displayType = DisplayType;
  packagingPart = PackagingPart;
  selectedNodeType!: number;
  @Input() isDarkTheme = false;

  constructor(private route: ActivatedRoute,
              private expenseCalculationService: ExpenseCalculationService,
              private authService: AuthService
  ) {
    super();
    this.isUserValidator = this.authService.isUserValidator();
  }

  dataSource?: PackagingSystemExpenseResultsDto[] | PackagingUnitExpenseResultsDto[];

  get dataSourceAsSystem(): PackagingSystemExpenseResultsDto[] {
      return this.dataSource as PackagingSystemExpenseResultsDto[];
  }

  get dataSourceAsUnit(): PackagingUnitExpenseResultsDto[] {
    return this.dataSource as PackagingUnitExpenseResultsDto[];
  }

  onSelectedVersionChanged() {
    this.dataSource = this.selectedExpenseResults;
  }

  onNodeSelected(node: TreeLevelParent | null) {
    if (!node) { return; }
    this.selectedNodeType = node.type;
    if (node.type === PackagingPart.System) {
      this.onSystemNodeChanged(node.id);
    } else if (node.type === PackagingPart.Unit) {
      this.onUnitNodeChanged(node.id);
    }
  }

  private findSystemResults(systemId: number): PackagingSystemExpenseResultsDto[] | null {
    const results: PackagingSystemExpenseResultsDto[] = [];
    for (const expenseResult of this.selectedExpenseResults) {
      const selectedResult = this.expenseCalculationService.findSystemResultRecursively(expenseResult, systemId);
      if (!selectedResult) { return null; }
      results.push(selectedResult);
    }

    return results;
  }

  private findUnitResults(unitId: number): PackagingUnitExpenseResultsDto[] | null {
    const results: PackagingUnitExpenseResultsDto[] = [];
    for (const expenseResult of this.selectedExpenseResults) {
      const selectedResult = this.expenseCalculationService.findUnitResultRecursively(expenseResult, unitId);
      if (!selectedResult) { return null; }
      results.push(selectedResult);
    }

    return results;
  }

  onSystemNodeChanged(systemId: number | null) {
    if (systemId == null) { return; }
    const selectedResult = this.findSystemResults(systemId);
    if (!selectedResult) { return; }
    this.dataSource = selectedResult;
  }

  onUnitNodeChanged(unitId: number | null) {
    if (unitId == null) { return; }
    const selectedResult = this.findUnitResults(unitId);
    if (!selectedResult) { return; }
    this.dataSource = selectedResult;
  }

  ngOnInit(): void {
    this.routeDataSubscription = this.route.data.subscribe(data => {
      const packagingUnit = data.packagingUnit;

      this.expenseResults = data.expenseResults;
      this.selectedExpenseResults = data.expenseResults[0];
      this.packagingSystem = packagingUnit;
      this.packagingPartType = PackagingPart.System;
      this.licenseFeeCountries = data.licenseFeeCountries;
      this.ecomodulationCountries = data.ecomodulationCountries;
      this.plasticTaxCountries = data.plasticTaxCountries;

      this.routeParamsSubscription = this.route.params.subscribe(params => {
        const licenseFeeResultId = params.licenseFeeId;
        const ecomodulationResultId = params.ecomodulationId;
        const plasticTaxResultId = params.plasticTaxId;

        const expenseResults = this.expenseResults.find(x => x[0].licenseFee?.id === licenseFeeResultId ||
                                                        x[0].plasticTax?.id === plasticTaxResultId ||
                                                        x[0].ecomodulation?.id === ecomodulationResultId);

        if (expenseResults) {
          this.selectedExpenseResults = expenseResults;
        }
      });
    });
  }
}
